import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import DashboardIcon from '@mui/icons-material/Dashboard'
import { useRoutes } from '../hooks/useRoutes'
import { useMemo } from 'react'

const NotFound = () => {
  const navigate = useNavigate()
  const appRoutes = useRoutes()

  const enabledRoutes = useMemo(
    () => appRoutes?.filter((route) => route?.enabled),
    [appRoutes]
  )

  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      height='100vh'
      gap={2}
    >
      <Typography variant='h4' color='error'>
        404 - Page Not Found
      </Typography>
      <Typography variant='body2'>
        The page you are looking for doesn’t exist.
      </Typography>
      <Box
        component={Button}
        size='small'
        variant='contained'
        startIcon={<DashboardIcon />}
        onClick={() => navigate(enabledRoutes?.[0]?.path)}
        textTransform={'none'}
        color={'primary'}
      >
        Go to {enabledRoutes?.[0]?.title}
      </Box>
    </Box>
  )
}

export default NotFound
